import { FC, ReactNode } from "react";
import { TabProvider } from "../TabPanels/TabContext";

type HorizontalTabProps = {
  children: ReactNode;
  tabs: { label: string; dlt: string; dld: string; tabContent: ReactNode }[];
  initialActiveTab?: number;
  theme?: "black" | "gray" | "white";
};

export const HorizontalTab: FC<HorizontalTabProps> = ({
  children,
  tabs,
  initialActiveTab,
  theme = "gray",
}) => {
  return (
    <TabProvider tabs={tabs} theme={theme} initialActiveTab={initialActiveTab}>
      {children}
    </TabProvider>
  );
};
